
















































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";

import DayRange from "./day-range.vue";

@Component({ components: { calendar: DayRange } })
export default class GuestRegistrationFooter extends Vue {
  @Prop({ type: Date, default: () => new Date() }) day!: Date;
  @Prop({ type: String, default: "" }) wiev!: string;
  @Prop({ type: Boolean, default: true }) show_plan_guests!: boolean;
  @Prop({ type: Boolean, default: true }) show_plan_children!: boolean;
  @Prop({ type: Boolean, default: true }) show_plan_pensioners!: boolean;
  @Prop({ type: Boolean, default: false }) show_plan_cell!: boolean;
  @Prop({ type: Boolean, default: true }) show_age!: boolean;
  @Prop({ type: Boolean, default: true }) show_phone_number!: boolean;
  @Prop({ type: Boolean, default: true }) show_document!: boolean;
  @Prop({ type: Boolean, default: true }) show_email!: boolean;
  @Prop({ type: Boolean, default: true }) show_room!: boolean;
  @Prop({ type: Boolean, default: true }) show_birthday!: boolean;
  @Prop({ type: Boolean, default: true }) show_ad!: boolean;
  @Prop({ type: Boolean, default: true }) show_order_number!: boolean;
  @Prop({ type: Boolean, default: true }) show_gender!: boolean;
  @Prop({ type: Boolean, default: true }) show_comment!: boolean;
  @Prop({ type: Boolean, default: true }) show_check!: boolean;
  @Prop({ type: Boolean, default: true }) show_table!: boolean;
  @Prop({ type: Boolean, default: true }) show_zit!: boolean;

  print(): void {
    window.print();
  }
}
